module.exports = __webpack_public_path__ + "static/media/logo.fe778f47.png";